module.exports = __webpack_public_path__ + "static/media/ornament.aca09a1c.svg";